import React from 'react';

const STORAGE = 'sessionStorage';

const FIVE_MINUTES_IN_MILLISECONDS = 5 * 60 * 1000;
const LOGIN_REDIRECT_KEY = 'savedSearchLoginRedirect';

export function useLoginRedirect() {
    const [isLoginRedirect, setIsLoginRedirect] = React.useState(false);

    React.useEffect(() => {
        const loginRedirect = window[STORAGE].getItem(LOGIN_REDIRECT_KEY);

        const isValidRedirect = Boolean(
            loginRedirect &&
                new Date().valueOf() - parseInt(loginRedirect, 10) <
                    FIVE_MINUTES_IN_MILLISECONDS,
        );

        if (isValidRedirect) {
            setIsLoginRedirect(true);
            window[STORAGE].removeItem(LOGIN_REDIRECT_KEY);
        }
    }, []);

    const onLogin = React.useCallback(() => {
        window[STORAGE].setItem(
            LOGIN_REDIRECT_KEY,
            new Date().valueOf().toString(),
        );
    }, []);

    return { isLoginRedirect, setIsLoginRedirect, onLogin };
}
